import React, { useState, useEffect } from "react";
import "../../admin/setup/warranty/warranty.scss";
import BackCard from "../../admin/setup/warranty/BackCard";
import FrontCard from "../../admin/setup/warranty/FrontCard";
import { _Api, _PdfApi } from "../../components/api/_call";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import resetBtn from "../../assets/images/pos/icons/reset-btn.png";
import {
  loading,
  Updateloading,
} from "../../components/common/helpers/toastify";
import { updateWarrantyPOS } from "source/app/appSlice";
import Loading from "pos/common/module/Loading/Loading";

const DEFAULT_FORM = {
  designation: "",
  title1: "",
  title2: "",
  subtitle: "",
  backTitle: "",
  footer1: "",
  footer2: "",
  footerSub: "",
};

const WarrantyCard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form, setForm] = useState(DEFAULT_FORM);
  const [logoSrc, setLogoSrc] = useState(null);
  const [searchlist, setSearchlist] = useState([]);
  const [searchsku, setSearchsku] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [isResetBtn, setIsResetBtn] = useState(false);
  const [cardInnerData, setCardInnerData] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [hasTemplate, setHasTemplate] = useState(false);
  const [colors, setColors] = useState([]);
  const [activeColor, setActiveColor] = useState(""); // empty string, not colors[0]
  const [customColor, setCustomColor] = useState("");

  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const card = useSelector((state) => state.app.card);

  // const currentColor =
  //   activeColor === "custom"
  //     ? customColor
  //     : (colors.find((p) => p.id === activeColor)?.color ??
  //       colors[0]?.color ??
  //       "");

  const currentColor =
    colors.find((p) => p.id === activeColor)?.color ?? colors[0]?.color ?? "";

  const hasCardData =
    (card && Object.keys(card).length > 0) ||
    (cardInnerData && Object.keys(cardInnerData).length > 0);
  const isButtonDisabled = !hasCardData || pdfLoading;
   const servicesData=card?.servies?.map(i=>i.name)

  const productData = cardInnerData
    ? cardInnerData
    : {
        transaction_date_raw: card?.date,
        product_details: { ...card?.product_details },
        servies:servicesData
      };

  const getWarrantyData = async () => {
    try {
      setLoadingModal(true);
      const res = await _Api({}, `api/v1/APP/warranty/get`);
      if (res.code === 200) {
        const orgLogo = res?.orgLogo;
        if (orgLogo) {
          localStorage.setItem("logo", orgLogo);
          setLogoSrc(orgLogo);
        }

        const d = res?.data;

        if (!d) {
          setHasTemplate(false);
          return;
        }

        setForm({
          designation: d.designation ?? "",
          title1: d.title1 ?? "",
          title2: d.title2 ?? "",
          subtitle: d.subtitle ?? "",
          backTitle: d.backTitle ?? "",
          footer1: d.footer1 ?? "",
          footer2: d.footer2 ?? "",
          footerSub: d.footerSub ?? "",
        });

        const colorList =
          Array.isArray(d?.colors) && d.colors.length > 0 ? d.colors : [];
        setColors(colorList);

        // auto-select first color by default
        if (colorList.length > 0) {
          setActiveColor(colorList[0].id);
          setCustomColor(
            colorList.find((c) => c.id === "custom")?.color ??
              colorList[0].color,
          );
        }

        // then override with saved pick_color if exists
        if (d.pick_color) {
          const matched = colorList.find(
            (p) => p.color.toLowerCase() === d.pick_color.toLowerCase(),
          );
          if (matched) {
            setActiveColor(matched.id);
          }
        }

        // const colorList =
        //   Array.isArray(d?.colors) && d.colors.length > 0 ? d.colors : [];
        // setColors(colorList);

        // // ← auto-select first color by default
        // if (colorList.length > 0) {
        //   setActiveColor(colorList[0].id);
        //   setCustomColor(colorList[0].color);
        // }

        // // then override with saved pick_color if exists
        // if (d.pick_color) {
        //   const matchedPreset = colorList.find(
        //     (p) => p.color.toLowerCase() === d.pick_color.toLowerCase(),
        //   );
        //   if (matchedPreset) {
        //     setActiveColor(matchedPreset.id);
        //   } else {
        //     setCustomColor(d.pick_color);
        //     setActiveColor("custom");
        //   }
        // }

        // if (d.logo) {
        //   setLogoSrc(d.logo);
        // }

        setHasTemplate(true);
      } else {
        setHasTemplate(false);
      }
    } catch (err) {
      console.error(err);
      setHasTemplate(false);
    } finally {
      setLoadingModal(false);
    }
  };

  useEffect(() => {
    getWarrantyData();
  }, []);

  const handlePrintWarranty = async () => {
    if (isButtonDisabled) return;
    setPdfLoading(true);
    const GetloadingID = loading();
    try {
      const blobData = await _PdfApi(
        {
          po_product_ids: cardInnerData
            ? [cardInnerData?.product_details?.order_id]
            : [card?.order_id],
          website_url: window.location.hostname,
          type: "pos",
          color: currentColor,
          skip_logo_fetch: true,
        },
        "api/v1/APP/warranty/print",
      );
      const blob = new Blob([blobData], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
      Updateloading(t, GetloadingID, t("Pdf is opened at another tab"));
    } catch (err) {
      console.error(err);
      Updateloading(t, GetloadingID, "Failed to generate print.", "e");
    } finally {
      setPdfLoading(false);
      dispatch(updateWarrantyPOS(null));
    }
  };

  const getsearchcatalog = async (search) => {
    search = search ? search.trim() : "";
    if (!search) {
      setSearchlist([]);
      setShowDropdown(false);
      return;
    }
    try {
      const res = await _Api(
        { stock_id: search, order_no: search },
        `api/v1/APP/warranty/getDataByStockId`,
      );
      if (res.code === 200) {
        setSearchlist(res?.data || []);
        setShowDropdown(true);
      } else {
        setSearchlist([]);
        setShowDropdown(false);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  return (
    <>
      {loadingModal ? (
        <Loading />
      ) : (
        <div className="main-body">
          <div className="main-body-row">
            <div className="main-body-row-left-col p-0">
              <div
                className="catalog-area-header-area-control"
                style={{ background: "#FBFBFB", padding: "20px 30px" }}
              >
                <div
                  className="catalog-area-header-area-control-left"
                  onClick={() => {
                    setCardInnerData(null);
                    setIsResetBtn(false);
                    setSearchsku("");
                    setSearchlist([]);
                    dispatch(updateWarrantyPOS(null));
                    navigate("/app/pos/menu");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <h1
                    className="heading text-uppercase"
                    style={{ fontSize: "20px" }}
                  >
                    {t("WARRANTY")}
                  </h1>
                </div>
                <div className="catalog-area-header-area-control-right">
                  <div
                    className={
                      parmissiondatashow?.pos_custom_order?.View
                        ? "custom-tooltip"
                        : "d-none"
                    }
                    onClick={() =>
                      navigate("/app/pos/warrantyCardOrderList", {
                        state: { fromClick: true },
                      })
                    }
                  >
                    <div>
                      <img
                        className="custom-order-img"
                        src={
                          base_assets + "images/pos/icons/custom-order-icon.png"
                        }
                        alt=""
                      />
                      <span
                        className="com-btn custom-tooltip-text"
                        style={{ width: "7.14vw" }}
                      >
                        {t("Purchase History")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: 8,
                  marginBottom: 6,
                  padding: "30px",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: 20,
                    alignItems: "center",
                    width: "50%",
                  }}
                >
                  <span style={{ fontWeight: "600", fontSize: "18px" }}>
                    View Card
                  </span>
                  {hasTemplate && (
                    <div
                      style={{
                        display: "flex",
                        gap: 18,
                        alignItems: "flex-end",
                        flexWrap: "wrap",
                      }}
                    >
                      {colors.map((p) => (
                        <div
                          key={p.id}
                          className={`swatch${activeColor === p.id ? " active" : ""}`}
                          style={{
                            background: p.color,
                            width: "26px",
                            height: "26px",
                          }}
                          onClick={() => setActiveColor(p.id)}
                          title={p.id}
                        />
                      ))}
                      {/* <div
                        className={`swatch-add${activeColor === "custom" ? " active" : ""}`}
                        style={
                          activeColor === "custom"
                            ? {
                                borderColor: "#fff",
                                boxShadow: "0 0 0 2.5px #333",
                                transform: "scale(1.1)",
                                width: "26px",
                                height: "26px",
                              }
                            : { width: "26px", height: "26px" }
                        }
                        title="Pick custom color"
                      >
                        <svg
                          width="13"
                          height="13"
                          viewBox="0 0 14 14"
                          fill="none"
                          stroke="#999"
                          strokeWidth="2.2"
                          strokeLinecap="round"
                        >
                          <line x1="7" y1="1" x2="7" y2="13" />
                          <line x1="1" y1="7" x2="13" y2="7" />
                        </svg>
                        <input
                          type="color"
                          value={customColor}
                          onChange={(e) => {
                            setCustomColor(e.target.value);
                            setActiveColor("custom");
                          }}
                        />
                      </div> */}
                    </div>
                  )}
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: 10,
                    alignItems: "center",
                    marginLeft: "auto",
                    width: "40%",
                    justifyContent: "flex-end",
                  }}
                >
                  {(isResetBtn || hasCardData) && (
                    <img
                      src={resetBtn}
                      alt="Reset"
                      style={{ cursor: "pointer", width: 20 }}
                      onClick={() => {
                        setCardInnerData(null);
                        setIsResetBtn(false);
                        setSearchsku("");
                        setSearchlist([]);
                        dispatch(updateWarrantyPOS(null));
                      }}
                    />
                  )}

                  <div className="com-search-area">
                    <input
                      type="text"
                      value={searchsku}
                      onChange={(e) => {
                        setSearchsku(e.target.value);
                        getsearchcatalog(e.target.value);
                      }}
                      placeholder={t("Search stock id / pos no...")}
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      autoComplete="off"
                    />
                    {searchsku && (
                      <img
                        className="com-search-area-clear"
                        src={base_assets + "images/icons/False.png"}
                        alt=""
                        onClick={() => {
                          setSearchsku("");
                          setSearchlist([]);
                          setShowDropdown(false);
                          setCardInnerData(null);
                          setIsResetBtn(false);
                        }}
                      />
                    )}
                    <ul
                      className={`dropdown-menu custom-search-dropdown1 ${
                        showDropdown && searchlist?.length ? "show" : ""
                      }`}
                      aria-labelledby="dropdownMenuButton1"
                    >
                      {searchlist.map((result, key) => (
                        <li
                          key={key}
                          className="dropdown-item pos-search-result-item"
                          onClick={() => {
                            setCardInnerData(result);
                            setIsResetBtn(true);
                            setShowDropdown(false);
                            setSearchsku(
                              result?.product_details?.stock_id ||
                                result?.product_details?.order_no?.[0] ||
                                "",
                            );
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 2,
                              alignItems: "flex-start",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "14px",
                                color: "#2A2A2A",
                                fontWeight: 600,
                              }}
                            >
                              {result?.product_details?.order_no}
                            </span>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "14px",
                              }}
                            >
                              <span
                                style={{ fontSize: "14px", color: "#A4A4A4" }}
                              >
                                {result?.product_details?.SKU}
                              </span>
                              <span
                                style={{ fontSize: "14px", color: "#A4A4A4" }}
                              >
                                {result?.product_details?.stock_id}
                              </span>
                            </div>
                            {/* <span
                              style={{ fontSize: "14px", color: "#A4A4A4" }}
                            >
                              {result?.product_details?.SKU}
                            </span>
                            <span
                              style={{ fontSize: "14px", color: "#A4A4A4" }}
                            >
                              {result?.product_details?.order_no?.[0]}
                            </span> */}
                          </div>
                        </li>
                      ))}
                    </ul>
                    <div
                      style={{ display: "flex", gap: 6, alignItems: "center" }}
                    >
                      <button className="com-search-area-left-img">
                        <img
                          src={base_assets + "images/pos/icons/scan-icon.png"}
                          alt=""
                        />
                      </button>
                      <img
                        className="com-search-area-img"
                        src={
                          base_assets + "images/pos/icons/magnifying-glass.png"
                        }
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                // style={{
                //   display: "flex",
                //   gap: "8%",
                //   flexWrap: "wrap",
                //   alignItems: "flex-start",
                //   padding: "16% 0%",
                //   transition: "opacity 0.3s ease",
                //   justifyContent: "center",
                //   alignItems: "center",
                // }}
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "center",
                  columnGap: "60px",
                  rowGap: "30px",
                  padding: "16% 0%",
                }}
              >
                <div className="card-preview-wrap">
                  {hasTemplate ? (
                    <FrontCard
                      data={{
                        title1: form.title1,
                        title2: form.title2,
                        subtitle: form.subtitle,
                      }}
                      color={currentColor}
                      logoSrc={logoSrc}
                    />
                  ) : (
                    <div
                      style={{
                        width: 320,
                        height: 204,
                        borderRadius: 12,
                        backgroundColor: "#EEEEEE",
                        display: "flex",
                        position: "relative",
                        overflow: "hidden",
                        transition: "background-color 0.25s ease",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <span style={{ marginBottom: "18px" }}>🚫</span>
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: 400,
                          color: "#2A2A2A",
                        }}
                      >
                        No Active Warranty Template Found
                        <br />
                        Please contact your administrator.
                      </span>
                    </div>
                  )}
                </div>

                <div className="card-preview-wrap">
                  {hasTemplate ? (
                    <BackCard
                      data={{
                        backTitle: form.backTitle,
                        footer1: form.footer1,
                        footer2: form.footer2,
                        footerSub: form.footerSub,
                      }}
                      color={currentColor}
                      productData={productData}
                    />
                  ) : (
                    <div
                      style={{
                        width: 320,
                        height: 204,
                        borderRadius: 12,
                        backgroundColor: "#EEEEEE",
                        display: "flex",
                        position: "relative",
                        overflow: "hidden",
                        transition: "background-color 0.25s ease",
                      }}
                    />
                  )}
                </div>
              </div>

              <div style={{ position: "absolute", bottom: 20, right: "30%" }}>
                <div
                  className={`${!isButtonDisabled ? "inventory-btn" : "inv-btn-disable"}`}
                  onClick={handlePrintWarranty}
                  style={{
                    opacity: isButtonDisabled ? 0.5 : 1,
                    cursor: isButtonDisabled ? "not-allowed" : "pointer",
                    pointerEvents: isButtonDisabled ? "none" : "auto",
                  }}
                >
                  <span>{t("Print Preview")}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WarrantyCard;
